export const BARCODE_CORRECTION_STATUS = {
  MATCHED: 'MATCHED',
  NOT_FOUND: 'NOT_FOUND',
  NOT_IN_WARRANT: 'NOT_IN_WARRANT',
} as const;

export type BarcodeCorrectionStatus =
  (typeof BARCODE_CORRECTION_STATUS)[keyof typeof BARCODE_CORRECTION_STATUS];
